(function () {
  function parseSort(value) {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : 9999;
  }

  function isAvailable(element) {
    if (!element) return false;
    if (element.dataset.available === "false") return false;
    if (element.dataset.available === "true") return true;
    return !element.disabled;
  }

  function pickPreferredOption(options) {
    const available = options.filter(isAvailable);
    return available[0] || options[0] || null;
  }

  function pickPreferredRadioItem(items) {
    const available = items.filter((item) => {
      const input = item.querySelector(".product-variant__input");
      return isAvailable(item) || isAvailable(input);
    });
    return available[0] || items[0] || null;
  }

  function sortPackagingVariants(root) {
    if (new URLSearchParams(window.location.search).has("variant")) return;

    (root || document).querySelectorAll("product-variants").forEach((productVariants) => {
      productVariants
        .querySelectorAll("[data-js-product-variant-container]")
        .forEach((container) => {
          const containerType = container.dataset.jsProductVariantContainer;

          if (containerType === "select") {
            const options = Array.from(
              container.querySelectorAll("option[data-sort]")
            );
            if (!options.length) return;

            options.sort(
              (a, b) => parseSort(a.dataset.sort) - parseSort(b.dataset.sort)
            );
            options.forEach((option) => container.appendChild(option));

            const preferredOption = pickPreferredOption(options);
            if (!preferredOption) return;

            if (container.value !== preferredOption.value) {
              container.value = preferredOption.value;
              container.dispatchEvent(new Event("change", { bubbles: true }));
            }
            return;
          }

          if (containerType === "radio") {
            const items = Array.from(
              container.querySelectorAll(".product-variant__item[data-sort]")
            );
            if (!items.length) return;

            items.sort(
              (a, b) => parseSort(a.dataset.sort) - parseSort(b.dataset.sort)
            );
            items.forEach((item) => container.appendChild(item));

            const preferredItem = pickPreferredRadioItem(items);
            const preferredInput = preferredItem
              ? preferredItem.querySelector(".product-variant__input")
              : null;

            if (preferredInput && !preferredInput.checked) {
              preferredInput.checked = true;
              preferredInput.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }
        });
    });
  }

  function init() {
    sortPackagingVariants();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
